/* hp26 v5w (draft) – HP26 Cooked gallery: arrows + keyboard for the square-tile slider. */
(() => {
  const init = (root) => {
    if (root.dataset.ckReady) return;
    root.dataset.ckReady = '1';
    const vp = root.querySelector('[data-ck-vp]');
    const nav = root.querySelector('[data-ck-nav]');
    const prev = root.querySelector('[data-ck-prev]');
    const next = root.querySelector('[data-ck-next]');
    if (!vp) return;
    const smooth = () => (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth');
    const update = () => {
      const max = vp.scrollWidth - vp.clientWidth;
      if (nav) nav.classList.toggle('is-off', max <= 2);
      if (prev) prev.disabled = vp.scrollLeft <= 2;
      if (next) next.disabled = vp.scrollLeft >= max - 2;
    };
    const page = (dir) => vp.scrollBy({ left: dir * vp.clientWidth * 0.9, behavior: smooth() });
    prev && prev.addEventListener('click', () => page(-1));
    next && next.addEventListener('click', () => page(1));
    vp.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); page(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); page(-1); }
    });
    vp.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    addEventListener('resize', update, { passive: true });
    update();
  };
  const boot = () => document.querySelectorAll('[data-ck]').forEach(init);
  boot();
  document.addEventListener('shopify:section:load', boot);
})();
